
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description: 'We discuss your event requirements, guest count, preferences, and any special requests to create a tailored experience.',
      icon: 'ri-chat-3-line'
    },
    {
      number: '02',
      title: 'Custom Planning',
      description: 'Our team designs a comprehensive service plan including staff allocation, equipment setup, and timeline coordination.',
      icon: 'ri-file-list-3-line'
    },
    {
      number: '03',
      title: 'Professional Setup',
      description: 'Our discreet staff arrives early to set up premium rolling stations and ensure everything is perfectly arranged.',
      icon: 'ri-settings-4-line'
    },
    {
      number: '04',
      title: 'Seamless Service',
      description: 'Throughout your event, our professional rolling artists provide exceptional service while maintaining complete discretion.',
      icon: 'ri-star-line'
    }
  ];

  return (
    <section id="process" className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold mb-4">Our Seamless Process</h3>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            From initial consultation to event completion, we ensure every detail 
            is handled with precision and professionalism.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-800 rounded-2xl p-8 h-full">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-emerald-500 rounded-full flex items-center justify-center mr-4">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <div className="text-3xl font-bold text-emerald-400">{step.number}</div>
                </div>
                <h4 className="text-xl font-bold mb-4">{step.title}</h4>
                <p className="text-gray-300">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <i className="ri-arrow-right-line text-2xl text-emerald-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button 
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="bg-emerald-500 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Planning Your Event
          </button>
        </div>
      </div>
    </section>
  );
}
